import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'
import 'moment/locale/ar'

// Import translation files
import enTranslation from './locales/en/translation.json'
import arTranslation from './locales/ar/translation.json'

const getLanguageFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const lang = urlParams.get('lang')
  // eslint-disable-next-line
  return lang && ['en', 'ar'].includes(lang) ? lang : 'en'
}

const getLanguageFromStorage = () => {
  return localStorage.getItem('i18nextLng') || 'en'
}

// Function to update URL with language parameter
const updateURLWithLanguage = language => {
  const url = new URL(window.location)
  url.searchParams.set('lang', language)
  window.history.replaceState({}, '', url)
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      ar: {
        translation: arTranslation,
      },
    },
    lng: getLanguageFromURL() || getLanguageFromStorage(),
    fallbackLng: 'en',
    debug: false,

    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  })

// Listen for language changes and update URL
i18n.on('languageChanged', lng => {
  updateURLWithLanguage(lng)

  // Update document direction for RTL support
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = lng

  // Update moment locale globally
  // Update moment.js locale to match i18n language
  moment.locale(lng === 'ar' ? 'ar' : 'en')
})

// Set initial document direction and moment locale
const currentLang = i18n.language
document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr'
document.documentElement.lang = currentLang
moment.locale(currentLang === 'ar' ? 'ar' : 'en')

export default i18n
